import { createAction } from '@reduxjs/toolkit'

import type { ApiKey, IssueKeyDto } from '@/services/apiKeys'

export const ApiKeysActions = {
  fetch: createAction('API_KEYS_FETCH'),
  create: createAction<IssueKeyDto>('API_KEYS_CREATE'),
  revoke: createAction<{ id: string }>('API_KEYS_REVOKE'),
}

export const InternalApiKeysActions = {
  set: createAction<ApiKey[]>('API_KEYS_SET'),
  remove: createAction<string>('API_KEYS_REMOVE'),
  setError: createAction<boolean>('API_KEYS_SET_ERROR'),
}
